export const LOCALES = {
    Default: 'en',
    English: 'en',
    Russian: 'ru',
    Lithuania: 'lt',
    Latvian: 'lv'
}